module.exports = __webpack_public_path__ + "img/speaker.c0021db7.svg";